var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ['/login', '/onboarding'].indexOf(this.$route.params.pathMatch) >= 0
      ? ''
      : 'max-1200' ],on:{"click":function (event) { return this$1.closeMenu(event); }}},[_c(_vm.currentComponent,{tag:"component"}),_c('notifications',{attrs:{"group":"dashboard-notification","position":"top left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }